// 引入unocss css
import '@/plugins/unocss'

// 引入iconfont js —— 暂时没用到，可以不引入，但模式如此
import '@/plugins/iconfontjs/font_symbol_v1.js';

// 引入element-plus 内置过渡动画 fade/zoom
import 'element-plus/theme-chalk/base.css'

// 引入全局样式
import '@/styles/index.scss' // 项目样式

// 初始化
import { createApp } from 'vue'

// 初始化多语言
import { setupI18n } from '@/plugins/vueI18n'

// 引入状态管理
import { setupStore } from '@/stores'

// 引入 element-plus
import { setupElementPlus } from '@/plugins/elementPlus'

// 引入icon
import '@/plugins/svgicon'

// 路由
import router, { setupRouter } from '@/router'

// 全局
import { emptyData, ListPlaceholder } from '@/components/customEmpty'

// 根
import App from './App.vue'

import './permission'

// 创建实例
const setupAll = async () => {
  const app = createApp(App)

  await setupI18n(app)

  setupStore(app)

  setupElementPlus(app)

  app.component('emptyData', emptyData)
  app.component('ListPlaceholder', ListPlaceholder)

  setupRouter(app)

  // 配置百度统计
  import('./permission').then(({ setupBaiduAnalytics }) => {
    setupBaiduAnalytics()
  })

  await router.isReady()

  app.mount('#app')
}

setupAll()
